<script lang="ts" setup>
import { PropType } from 'vue'

import HalvesConstructorPanel from '@/components/Halves/HalvesConstructorPanel.vue'
import HalvesConstructorImage from '@/components/Halves/HalvesConstructorImage.vue'

import { ConstructorPizza, ProductPizza } from '@/types/api/api-v3/halves'

const props = defineProps({
  constructorPizza: {
    type: Object as PropType<ConstructorPizza>,
    required: true,
  },
  wholePizza: {
    type: Object as PropType<ProductPizza | undefined>,
    required: false,
    default: undefined,
  },
})

const emits = defineEmits(['removeHalveOfConstructor'])

const removeHalveOfConstructor = (side: string) =>
  emits('removeHalveOfConstructor', side)
</script>

<template>
  <div class="halves-container">
    <halves-constructor-image
      :constructor-pizza="props.constructorPizza"
      class="halves-container__image"
    />
    <halves-constructor-panel
      :whole-pizza="props.wholePizza"
      :constructor-pizza="props.constructorPizza"
      @remove-halve-of-constructor="removeHalveOfConstructor"
    />
  </div>
</template>

<style lang="scss">
.halves-container {
  position: sticky;
  top: 150px;
  width: 384px;
  height: 100%;

  @include media('<=desktop-mini') {
    bottom: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 120px;
    margin-top: 48px;
    background-color: #fff;

    &__image {
      display: none !important;
    }
  }

  @include media('<=portrait-phone') {
    height: 75px;
  }
}
</style>
